module.exports = __webpack_public_path__ + "img/16.a9b3f7ab.png";